const PATHS = {
  printer: (
    <>
      <path d="M6 9V3h12v6" />
      <rect x="3" y="9" width="18" height="8" rx="2" />
      <path d="M7 17v4h10v-4" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v12" />
      <path d="m7 11 5 5 5-5" />
      <path d="M4 20h16" />
    </>
  ),
  help: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.6 2.6 0 0 1 5 .8c0 1.8-2.5 2-2.5 3.7" />
      <path d="M12 17.5h.01" />
    </>
  ),
  wifi: (
    <>
      <path d="M2.5 8.5a16 16 0 0 1 19 0" />
      <path d="M5.5 12a11.5 11.5 0 0 1 13 0" />
      <path d="M8.5 15.5a7 7 0 0 1 7 0" />
      <path d="M12 19h.01" />
    </>
  ),
  headset: (
    <>
      <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
      <rect x="2.5" y="13" width="4" height="6" rx="1.6" />
      <rect x="17.5" y="13" width="4" height="6" rx="1.6" />
      <path d="M19.5 19v.5a2.5 2.5 0 0 1-2.5 2.5h-3" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 12a8 8 0 1 1-2.6-5.9" />
      <path d="M20 3v5h-5" />
    </>
  ),
  tools: (
    <>
      <path d="M14.5 6.5a3.5 3.5 0 0 0 4.6 4.6L21 13l-8 8-2-2 8-8" />
      <path d="M6 3 3 6l3.5 3.5L9 7z" />
    </>
  ),
  scanner: (
    <>
      <rect x="3" y="4" width="18" height="10" rx="2" />
      <path d="M3 18h18" />
      <path d="M7 21h10" />
      <path d="M8 9h8" />
    </>
  ),
  mobile: (
    <>
      <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
      <path d="M11 18.5h2" />
    </>
  ),
  cloud: (
    <>
      <path d="M7 18a4 4 0 0 1-.4-8A6 6 0 0 1 18 10.5a3.75 3.75 0 0 1-.5 7.5z" />
    </>
  ),
  pages: (
    <>
      <rect x="7" y="3" width="13" height="16" rx="2" />
      <path d="M4 7v12a2 2 0 0 0 2 2h10" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3.5 7 8.5 6 8.5-6" />
    </>
  ),
  lock: (
    <>
      <rect x="4.5" y="10" width="15" height="10" rx="2.5" />
      <path d="M8 10V7.5a4 4 0 0 1 8 0V10" />
    </>
  ),
  diagnostic: (
    <>
      <rect x="3" y="4" width="18" height="13" rx="2" />
      <path d="m6.5 12 2.5-3 2.5 4 2-2.5 1.5 1.5h3" />
      <path d="M9 21h6" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 5 6v6c0 4.2 3 7.6 7 9 4-1.4 7-4.8 7-9V6z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5.2l3.2 2" />
    </>
  ),
  badge: (
    <>
      <circle cx="12" cy="9" r="5.5" />
      <path d="m8 14-1.5 7L12 18l5.5 3L16 14" />
    </>
  ),
  tag: (
    <>
      <path d="M11 3H4v7l10 10 7-7L11 3Z" />
      <path d="M7.5 7.5h.01" />
    </>
  ),
};

export default function Icon({ name, size = 24 }) {
  const path = PATHS[name] || PATHS.printer;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}
